import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: `${API_URL}/api/funded`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Raw base URL (used for CSV export links that must carry the auth header via fetch).
export const FUNDED_BASE = `${API_URL}/api/funded`;

export const fundedAPI = {
  // Dashboard
  getStats: () => api.get('/stats'),
  getActivity: (params = {}) => api.get('/activity', { params }),
  getCharts: () => api.get('/charts'),

  // Clients (funded book)
  getClients: (params = {}) => api.get('/clients', { params }),
  getClient: (clientId) => api.get(`/clients/${encodeURIComponent(clientId)}`),
  addClientNote: (clientId, data) => api.post(`/clients/${encodeURIComponent(clientId)}/notes`, data),

  // Ledger (fundings & commissions)
  getLedger: (params = {}) => api.get('/ledger', { params }),

  // Lenders
  getLenders: () => api.get('/lenders'),

  // Lead ↔ funded-client matching
  getLeadMatches: (params = {}) => api.get('/lead-matches', { params }),
  confirmLeadMatch: (leadId, data) => api.post(`/lead-matches/${leadId}/confirm`, data),
  dismissLeadMatch: (leadId) => api.post(`/lead-matches/${leadId}/dismiss`),
  autoConfirmLeadMatches: () => api.post('/lead-matches/auto-confirm'),

  // Unmatched deposits
  getUnmatched: (params = {}) => api.get('/unmatched', { params }),
  matchDeposit: (depositId, data) =>
    api.post(`/unmatched/${encodeURIComponent(depositId)}/match`, data),
};

// Download a CSV export of the current ledger filters (keeps the auth header).
export async function downloadLedgerCSV(params = {}) {
  const token = localStorage.getItem('token');
  const qs = new URLSearchParams(params).toString();
  const res = await fetch(`${FUNDED_BASE}/ledger/export?${qs}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Export failed');
  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${params.type || 'fundings'}-export.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export default fundedAPI;
